var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 150,
    height: 114.267,
    viewBox: "0 0 150 114.267",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "email",
    transform: "translate(-45.8 -94.59)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3888",
    "data-name": "Path 3888",
    d: "M195.8,106.314v90.82a27.85,27.85,0,0,1-1.339,4.145c-2.624,5.248-7.03,7.58-12.814,7.578q-60.847-.013-121.695,0c-.244,0-.488,0-.732,0-4.46-.116-8.273-1.725-10.769-5.474-1.231-1.85-1.789-4.148-2.651-6.243v-90.82a27.685,27.685,0,0,1,1.337-4.145c2.626-5.244,7.025-7.581,12.814-7.58q60.848.016,121.7.006c.244,0,.488,0,.732,0,4.46.116,8.273,1.725,10.769,5.474C194.38,101.921,194.937,104.219,195.8,106.314ZM60.918,103.459,120.7,162.724,180,103.459ZM138.57,158.15a1.358,1.358,0,0,0-.24.156q-6.739,6.721-13.476,13.446c-2.628,2.619-4.905,2.611-7.566-.025q-6.5-6.442-13-12.892c-.365-.362-.749-.7-.819-.769L61.593,199.948H180.368Zm-83.912,35.2L96.7,151.31,54.658,109.622Zm132.284-83.22L145.378,151.69l41.564,41.563Z",
    transform: "translate(0 0)",
    fill: "#674188"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/Email.97956ec17137e86fdff2318804a73b83.svg";
export { ForwardRef as ReactComponent };